module.exports = __webpack_public_path__ + "static/6-77869a90161e46506866d8386ee7e66f.jpg";